<template>
  <q-page padding>
    <q-card class="scroll">
      <q-card-section>
        <form-events-incident
          v-model="incident"
          :type-incident="$route.query.typeKey"
          :all-types="!$route.query.typeKey && isManager"
          @submit="onSubmit"
        />
        <lwf-form-submit @submit="goBack" />
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
import { EVENTS_MAIN_TYPE_INCIDENT } from '@/consts/events'
import { createNamespacedHelpers } from 'vuex'
import { ROUTE_NAME_TERRAIN_CIRCUIT_ACTIF, ROUTE_NAME_TERRAIN_SERVICE_ACTIF } from '@/router/terrain'
import { loadingHandler, toast } from '@/utils/ui'
import FormEventsIncident from 'components/forms/Events/FormEventsIncident'
import LwfFormSubmit from 'components/core/LwfFormSubmit'
import { getLocation } from '@/utils/io/geolocation'
import { ROUTE_NAME_TERRAIN_EVENTS_INCIDENT } from '@/router/terrain/routesEvents'
import { MODAL_EVENT_UPDATE_SERVICE_EVENT } from '@/consts/app'
import { SERVICE_POST_EVENT } from '@/store/modules/service/action-types'
import { getAgencyEvent, postAgencyEvent } from '@/utils/api/event'

const storeService = createNamespacedHelpers('service')
const storeUser = createNamespacedHelpers('user')
export default {
  name: 'Incident',
  EVENTS_MAIN_TYPE_INCIDENT,
  components: { LwfFormSubmit, FormEventsIncident },
  props: {
    reference: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      incident: {}
    }
  },
  computed: {
    ...storeService.mapGetters({
      serviceActif: 'serviceActif',
      isCircuit: 'isCircuit',
      getEventByReference: 'getEventByReference'
    }),
    ...storeUser.mapGetters({
      isManager: 'isManager'
    })
  },
  watch: {
    reference: {
      immediate: true,
      async handler (v) {
        if (v) {
          this.fromStore()
        } else {
          this.incident = {}
        }
      }
    }
  },
  methods: {
    ...storeService.mapActions({
      postEvent: SERVICE_POST_EVENT
    }),
    async postAgencyEvent (incident) {
      const { event } = await postAgencyEvent(incident)
      return event
    },
    async fromStore () {
      const incident = this.serviceActif
        ? this.getEventByReference(this.reference)
        : (await loadingHandler(() => getAgencyEvent(this.reference))).event
      if (!incident) {
        toast.negative('Impossible de trouver la main courante')
        this.$router.go(-1)
      }
      this.incident = _.cloneDeep(incident)
    },
    onSubmit (incident) {
      return loadingHandler(
        async () => {
          if (!incident.id) {
            incident.location = await getLocation()
          }
          const _incident = await (
            this.serviceActif
              ? this.postEvent(incident)
              : this.postAgencyEvent(incident)
          )
          if (!incident.id && this.$route.name === ROUTE_NAME_TERRAIN_EVENTS_INCIDENT) {
            await this.$router.replace({
              name: ROUTE_NAME_TERRAIN_EVENTS_INCIDENT,
              params: { reference: _incident.reference }
            })
          } else {
            this.fromStore()
          }
          toast.positive(`Les informations ont été transmises`)
          this.$ui.$emit(MODAL_EVENT_UPDATE_SERVICE_EVENT, [this.incident])
        },
        { message: 'Signalement en cours...' })
    },
    goBack () {
      if (this.serviceActif) {
        this.$router.push({
          name: this.isCircuit
            ? ROUTE_NAME_TERRAIN_CIRCUIT_ACTIF
            : ROUTE_NAME_TERRAIN_SERVICE_ACTIF
        })
      } else {
        this.$router.replace('/')
      }
    }
  }
}
</script>

<style scoped>

</style>
